import axios from 'axios';
import header from "./header";
const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;
const apiV2 = process.env.VUE_APP_API_V2;

class OrderService {

   newOrder(data) {
      return axios.post(`${baseUrl + apiV2}/order/new`, {data}, header)
   }

   approveOrder(orderId) {
      return axios.post(`${baseUrl + apiV2}/order/approve`, {orderId}, header)
   }

   checkinCheckout(bikeId, orderId, status) {
      return axios.post(`${baseUrl + apiV2}/order/checkin`, {bikeId, orderId, status}, header)
   }

   cancelOrder(orderId, status, info, obs) {
      return axios.post(`${baseUrl + apiV2}/order/cancel`, {orderId, status, info, obs}, header)
   }

   getOrders(userId, perPage, page, filter = '') {
      const query = userId ? `?userId=${userId}&perPage=${perPage}&page=${page}&filter=${filter}` : `?perPage=${perPage}&page=${page}&filter=${filter}`

      return axios.get(`${baseUrl + apiV1}/order/orders${query}`,  header)
   }

  getOrderExtract(perPage, page, customerId ) {
    const query = `?perPage=${perPage}&page=${page}`

    return axios.get(`${baseUrl + apiV1}/order/extract/${customerId}${query}`,  header)
  }

   statusOrder(data) {
      return axios.put(`${baseUrl + apiV1}/order/status`, {data}, header)
   }

    viewOrder(data) {
        return axios.put(`${baseUrl + apiV1}/order/viewed`, {data},  header)
    }

    changeBookingDatesOrder(data) {
      return axios.put(`${baseUrl + apiV1}/order/change-booking-dates`, {data}, header)
    }

   charge(data) {
      return axios.post(`${baseUrl + apiV1}/order/charge`, {data}, header)
   }

   postChat(data) {
      return axios.post(`${baseUrl + apiV1}/order/chat`, data, header)
   }

   getChat(orderId, viewedBy) {
      return axios.get(`${baseUrl + apiV1}/order/chat/${orderId}/${viewedBy}`, header)
   }

}

export default new OrderService();
